import gql from 'graphql-tag'

export const listingsFragment = gql`
  fragment listings on ListingConnection {
    edges {
      node {
        id
        hash
        description
        isPublic
        event {
          id
          name
          slug
        }
        eventType {
          id
          title
        }
        seller {
          id
          firstname
          avatar
        }
        numberOfTicketsInListing
        price {
          totalPriceWithTransactionFee {
            formattedAmount
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
`
